export default "/images/061e407a04cbdf36ff2b2cca37b04c1f.avif";